import React, { useRef } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import ConfirmEmailPopup from 'apps/auth/components/email/ConfirmEmailPopup';
import BetaPromoStories from 'apps/auth/components/send/optIn/BetaPromoStories';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import {
    AF_RECIPIENT_DETAILS_REQUIRED_BANNER_CLICKED,
    COMPLETE_PROFILE_BANNER_CLICKED,
    INCREASE_LIMITS_BANNER_CLICKED,
    OPT_IN_BETA_CLICKED,
    VERIFY_INDENTITY_BANNER_CLICKED,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCENARIO_ID } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { AUTH_EMAIL_CONFIRM_PREVIEW } from 'apps/auth/constants/UrlConstants';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import DocumentExpiringModal from './modals/DocumentExpiringModal';
import IncreaseLowRiskLimitModal from './modals/IncreaseLowRiskLimitModal';
import IncreaseUsaLimitModal from './modals/IncreaseUsaLimitModal';
import NotificationWrapper from './NotificationWrapper';
import AntifraudRecipientNotifyModal from './send/cheque/modals/AntifraudRecipientNotifyModal';

const Notification = (props) => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    const popupFullwidthRef = useRef(null);

    const {
        confirmEmailNotification,
        retryOnfidoTitle,
        renewSendLimitTitle,
        renewProfileLimitTitle,
        popupGaDocExpTitle,
        popupGtDocExpTitle,
        popupGaDocExpDescription,
        popupGtDocExpDescription,
        increaseLimit,
        upgradeLimits,
        onfidoTitle,
        notificationFraudTitle,
        fillProfileNotification,
        optInBetaInfo,
    } = usePageMessages();
    const { canConfirmEmail, increaseGtSendingLimit } = useAuth();
    const {
        show_email_promocode_page: showSpecialEmailPromoCode,
        retryConfirmation,
        showOptInNotificationToBetaPs3,
        gtDocumentWillExpired,
        gaDocumentWillExpired,
        increaseLimitUrl,
        canShowThreeMonthInfo,
        kycLink,
        hasDraft,
        fraudNotificationLink,
        fraudChequeRecipientDetails,
        draftOnfidoTooManyAttempts,
        fraudOnfidoTooManyAttempts,
        verifyYourIdentity,
        fraudNotificationEventName,
        fraudScenarioId,
        fillProfile,
        increaseLimitUSA,
        promoSlidesOptInBeta,
    } = useExtra();

    const extra = useExtra();

    const notNowButtonClick = () => {
        popupFullwidthRef?.current?.close();
    };

    const inviteButtonClick = () => {
        return false;
    };

    const openDocumentInfoModal = (e, url, headerText, description, canCloseModal = true) => {
        e.preventDefault();
        const header = <DangerouslyHtml dangerouslyHtml={headerText} />;
        props.toggleModal(true, <DocumentExpiringModal url={url} headerText={header} description={description} canCloseModal={canCloseModal} />, false);
    };

    if (showOptInNotificationToBetaPs3) {
        return (
            <>
                <NotificationWrapper
                    isNewMainScreen={props.isNewMainScreen}
                    isLeftAligned
                    iconName={'paysend-rounded'}
                    title={optInBetaInfo}
                    onClick={() => {
                        amplitude.getInstance().logEvent(OPT_IN_BETA_CLICKED);
                        popupFullwidthRef.current?.open(
                            <BetaPromoStories
                                popupFullwidthRef={popupFullwidthRef}
                                hasTopButton={promoSlidesOptInBeta?.not_now}
                                sliders={promoSlidesOptInBeta}
                                onTopButtonClick={notNowButtonClick}
                                onBottomButtonClick={inviteButtonClick}
                                modalRef={props.modalRef}
                            />,
                        );
                    }}
                />
                <PopupNew ref={popupFullwidthRef} fullwidthPopup />
            </>
        );
    } else if (fillProfile) {
        return (
            <NotificationWrapper
                isNewMainScreen={props.isNewMainScreen}
                url={'/auth/profile/registration/finish'}
                title={fillProfileNotification}
                onClick={(_e) => {
                    amplitude.getInstance().logEvent(COMPLETE_PROFILE_BANNER_CLICKED);
                }}
                isTagA
            />
        );
    } else if (fraudNotificationLink) {
        return (
            <NotificationWrapper
                isNewMainScreen={props.isNewMainScreen}
                url={fraudNotificationLink}
                title={notificationFraudTitle}
                isTagA
                onClick={(e) => {
                    if (fraudNotificationEventName) {
                        amplitude.getInstance().logEvent(fraudNotificationEventName, { [SCENARIO_ID]: fraudScenarioId });
                    }
                    if (fraudOnfidoTooManyAttempts) {
                        e.preventDefault();
                        props.toggleChat(true);
                    } else if (fraudChequeRecipientDetails) {
                        amplitude.getInstance().logEvent(AF_RECIPIENT_DETAILS_REQUIRED_BANNER_CLICKED, { [SCENARIO_ID]: fraudScenarioId });
                        e.preventDefault();
                        props.toggleModal(true, <AntifraudRecipientNotifyModal extra={extra} shareDetails={extra.shareDetails} />);
                    }
                }}
            />
        );
    } else if (hasDraft) {
        return (
            <NotificationWrapper
                isNewMainScreen={props.isNewMainScreen}
                url={kycLink}
                title={onfidoTitle}
                isTagA
                onClick={(e) => {
                    amplitude.getInstance().logEvent(verifyYourIdentity ? INCREASE_LIMITS_BANNER_CLICKED : VERIFY_INDENTITY_BANNER_CLICKED);
                    if (draftOnfidoTooManyAttempts) {
                        e.preventDefault();
                        props.toggleChat(true);
                    }
                }}
            />
        );
    } else if (canConfirmEmail) {
        const url = showSpecialEmailPromoCode ? AUTH_EMAIL_CONFIRM_PREVIEW : '#';
        return (
            <>
                <NotificationWrapper
                    isNewMainScreen={props.isNewMainScreen}
                    url={url}
                    onClick={(e) => {
                        if (!showSpecialEmailPromoCode) {
                            e.preventDefault();
                            popupRef.current?.open(<ConfirmEmailPopup popupRef={popupRef} />);
                        }
                    }}
                    title={confirmEmailNotification}
                />
                <PopupNew ref={popupRef} />
            </>
        );
    } else if (retryConfirmation) {
        return <NotificationWrapper isNewMainScreen={props.isNewMainScreen} url={kycLink} title={retryOnfidoTitle} isTagA />;
    } else if (canShowThreeMonthInfo) {
        return <NotificationWrapper isNewMainScreen={props.isNewMainScreen} url={kycLink} title={upgradeLimits} isTagA />;
    } else if (gtDocumentWillExpired) {
        return (
            <NotificationWrapper
                isNewMainScreen={props.isNewMainScreen}
                title={renewSendLimitTitle}
                onClick={(e) => {
                    openDocumentInfoModal(e, increaseLimitUrl, popupGtDocExpTitle, popupGtDocExpDescription);
                }}
            />
        );
    } else if (gaDocumentWillExpired) {
        return (
            <NotificationWrapper
                isNewMainScreen={props.isNewMainScreen}
                title={renewProfileLimitTitle}
                onClick={(e) => {
                    openDocumentInfoModal(e, increaseLimitUrl, popupGaDocExpTitle, popupGaDocExpDescription);
                }}
            />
        );
    } else if (increaseGtSendingLimit) {
        if (increaseLimitUSA) {
            return (
                <NotificationWrapper
                    isNewMainScreen={props.isNewMainScreen}
                    url={increaseLimitUrl}
                    title={increaseLimit}
                    onClick={(e) => {
                        e.preventDefault();
                        props.toggleModal(true, <IncreaseUsaLimitModal />, false);
                    }}
                />
            );
        } else {
            return (
                <>
                    <NotificationWrapper
                        isNewMainScreen={props.isNewMainScreen}
                        url={increaseLimitUrl}
                        title={increaseLimit}
                        onClick={(e) => {
                            e.preventDefault();
                            modalRef.current.open(<IncreaseLowRiskLimitModal modalRef={modalRef} />);
                        }}
                    />
                    <ModalNew ref={modalRef} />
                </>
            );
        }
    }

    return null;
};
export default connect(null, { toggleModal, toggleChat })(Notification);
